import { WeeklyMenuResponse, DayMealsResponse, DayOfWeek, MealType } from '@/types';
import { apiClient } from './api';

export const weeklyMenuService = {
    // Obtener menú de la semana actual
    async getCurrentWeekMenu(token: string): Promise<WeeklyMenuResponse> {
        return apiClient.get('/menus/current', token);
    },

    // Obtener o crear menú para una semana específica
    async getOrCreateWeeklyMenu(weekStartDate: string, token: string): Promise<WeeklyMenuResponse> {
        return apiClient.post(`/menus/week/${weekStartDate}`, {}, token);
    },

    // Obtener menú específico
    async getWeeklyMenu(menuId: number, token: string): Promise<WeeklyMenuResponse> {
        return apiClient.get(`/menus/${menuId}`, token);
    },

    // Obtener todos los menús del usuario
    async getUserWeeklyMenus(token: string): Promise<WeeklyMenuResponse[]> {
        return apiClient.get('/menus', token);
    },

    // Agregar receta al menú
    async addRecipeToMenu(
        menuId: number,
        dayOfWeek: DayOfWeek,
        mealType: MealType,
        recipeId: number,
        token: string
    ): Promise<WeeklyMenuResponse> {
        return apiClient.post(
            `/menus/${menuId}/days/${dayOfWeek}/meals/${mealType}/recipes/${recipeId}`,
            {},
            token
        );
    },

    // Eliminar receta del menú
    async removeRecipeFromMenu(
        menuId: number,
        dayOfWeek: DayOfWeek,
        mealType: MealType,
        token: string
    ): Promise<WeeklyMenuResponse> {
        console.log(`📡 DELETE: /menus/${menuId}/days/${dayOfWeek}/meals/${mealType}`);

        const response = await apiClient.delete(
            `/menus/${menuId}/days/${dayOfWeek}/meals/${mealType}`,
            token
        );

        console.log('✅ Delete response:', response);
        return response;
    },

    // Obtener comidas de un día específico
    async getDayMeals(menuId: number, dayOfWeek: DayOfWeek, token: string): Promise<DayMealsResponse> {
        return apiClient.get(`/menus/${menuId}/days/${dayOfWeek}`, token);
    },

    // Eliminar menú semanal
    async deleteWeeklyMenu(menuId: number, token: string): Promise<boolean> {
        return apiClient.delete(`/menus/${menuId}`, token);
    }
};